"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyFormAnswer = void 0;
function createEmptyFormAnswer() {
    return {
        value: '',
        issueId: undefined,
        comment: undefined,
        fail: undefined,
        flag: null,
        photos: undefined,
        score: null,
        issue: undefined,
        text: undefined,
        notApplicable: false,
    };
}
exports.createEmptyFormAnswer = createEmptyFormAnswer;
exports.default = createEmptyFormAnswer;
